/**
 * Created by sung on 2017-05-25.
 */
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'deviceDetailValueCheck'})
export class DeviceDetailValueCheckPipe implements PipeTransform {
    transform(value: string, format: string = ""): string {
        if (!value || value==="" || value==null) return "-";
        return value;
    }
}


// WEBPACK FOOTER //
// ./src/app/pipe/deviceDetailValue_nullFormat.pipe.ts